import {
  ADD_USER,
  ADD_USER_FAILURE,
  ADD_USER_FREE_PREMIUM,
  ADD_USER_FREE_PREMIUM_FAILURE,
  ADD_USER_FREE_PREMIUM_SUCCESS,
  ADD_USER_SUCCESS,
  EDIT_USER,
  EDIT_USER_FAILURE,
  EDIT_USER_SUCCESS,
  SEND_ADMIN_MESSAGE,
  SEND_ADMIN_MESSAGE_FAILURE,
  SEND_ADMIN_MESSAGE_SUCCESS,
} from '../Actiontype';

export const AddUser = data => ({
  payload: data,
  type: ADD_USER,
});
export const AddUserSuccess = response => ({
  payload: response,
  type: ADD_USER_SUCCESS,
});
export const AddUserFailure = response => ({
  payload: response,
  type: ADD_USER_FAILURE,
});

export const EditUser = data => ({
  payload: data,
  type: EDIT_USER,
});
export const EditUserSuccess = response => ({
  payload: response,
  type: EDIT_USER_SUCCESS,
});
export const EditUserFailure = response => ({
  payload: response,
  type: EDIT_USER_FAILURE,
});

/* Admin send Message to User  */
export const SendAdminMessage = data => ({
  payload: data,
  type: SEND_ADMIN_MESSAGE,
});
export const SendAdminMessageSuccess = response => ({
  payload: response,
  type: SEND_ADMIN_MESSAGE_SUCCESS,
});
export const SendAdminMessageFailure = response => ({
  payload: response,
  type: SEND_ADMIN_MESSAGE_FAILURE,
});

/* Admin Add Free Primium to User  */
export const AddUserFreePremium = data => ({
  payload: data,
  type: ADD_USER_FREE_PREMIUM,
});
export const AddUserFreePremiumSuccess = response => ({
  payload: response,
  type: ADD_USER_FREE_PREMIUM_SUCCESS,
});
export const AddUserFreePremiumFailure = response => ({
  payload: response,
  type: ADD_USER_FREE_PREMIUM_FAILURE,
});
